module.exports = __webpack_public_path__ + "img/ig-icon.e7390788.svg";